import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import { AuthProvider } from "./AuthContext";
import { CartProvider } from "./context/CartContext";
import Home from "./pages/Home";
import Rooms from "./pages/Rooms";
import Wellness from "./pages/Wellness";
import PBPavilion from "./pages/PBPavilion";
import Booking from "./pages/Booking";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import Points from "./pages/Points";
import WellnessReservationForm from "./components/WellnessReservationForm";
import PBPavilionReservationForm from "./components/PBPavilionReservationForm";
import FAQ from "./pages/faq";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminDashboard from "./pages/AdminDashboard";
import Cart from "./pages/Cart";
import BookingConfirmed from "./pages/BookingConfirmed";


function App() {
    return (
        <AuthProvider>
        <CartProvider>
            <Router>
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/rooms" element={<Rooms />} />
                    <Route path="/wellness" element={<Wellness />} />
                    <Route path="/pbpavilion" element={<PBPavilion />} />
                    <Route path="/booking" element={<Booking />} />
                    <Route path="/sign-in" element={<SignIn />} />
                    <Route path="/sign-up" element={<SignUp />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/points" element={<Points />} />
                    <Route path="/reserve-wellness" element={<WellnessReservationForm />} />
                    <Route path="/reserve-pavilion" element={<PBPavilionReservationForm />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/booking-confirmed" element={<BookingConfirmed />} />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute requireAdmin={true}>
                            <AdminDashboard />
                            </ProtectedRoute>
                        }
                        />
                </Routes>
            </Router>
        </CartProvider>
        </AuthProvider>
    );
}

export default App;
